import React, { useState } from "react";
import { ModifyFormSection } from "./modify-form-section";
import { FluentInput } from "../../../../../../components/FluentUI/Fluent-Input";
import { FluentButton } from "../../../../../../components/FluentUI/Fluent-Button";
import FluentUiIcon from "../../../../../../assets/fluent-ui-icon";
import {
  AddFieldToSectionUtil,
  AddSectionUtil,
  DeleteSectionUtil,
  LabelBlurUtil,
  RemoveEmptyIds,
  RenameSectionUtil,
} from "./form-design-util";
import PropTypes from "prop-types";
import { ModifyFormRightPanel } from "../common-components/modify-form-right-panel";
import { scrollToBottomByClassName } from "../../../../../../util/general-helpers";

export const ModifyForm = ({
  allForms,
  currentForm,
  setAllForms,
  RenameForm,
  setFormView,
}) => {
  const [validationMessage, setValidationMessage] = useState("");
  const [sectionErrors, setSectionErrors] = useState({});

  const hasAnyError = !!validationMessage || Object.values(sectionErrors).some((msg) => !!msg);

  const onSectionValidationChange = (displayOrder, message) => {
    setSectionErrors((prev) => ({ ...prev, [displayOrder]: message }));
  };

  const AddFieldToSection = (subFormDisplayOrder, field) => {
    const newAllForms = AddFieldToSectionUtil(
      allForms.data,
      currentForm.DisplayOrder,
      subFormDisplayOrder,
      field
    );

    setAllForms((prev) => ({
      ...prev,
      data: newAllForms,
    }));
  };

  const AddSection = () => {
    const newAllForms = AddSectionUtil(allForms.data, currentForm.DisplayOrder);

    setAllForms((prev) => ({
      ...prev,
      data: newAllForms,
    }));
    scrollToBottomByClassName("modify-form-content");
  };

  const RenameSection = (label, subFormDisplayOrder) => {
    const trimmed = label.trim();
    if (!trimmed) return;

    const isDuplicate = currentForm.SubForms.some(
      (s) => s.DisplayOrder !== subFormDisplayOrder && s.Label === trimmed
    );
    if (isDuplicate) return;

    const newAllForms = RenameSectionUtil(
      allForms.data,
      currentForm.DisplayOrder,
      subFormDisplayOrder,
      trimmed
    );

    setAllForms((prev) => ({
      ...prev,
      data: newAllForms,
    }));
  };

  const DeleteSection = (subFormDisplayOrder) => {
    const { newAllForms, newSubFormId } = DeleteSectionUtil(
      allForms.data,
      currentForm.DisplayOrder,
      subFormDisplayOrder
    );

    setSectionErrors((prev) => {
      const updated = { ...prev };
      delete updated[subFormDisplayOrder];
      return updated;
    });

    setAllForms((prev) => ({
      ...prev,
      DynamicSubFormIdsToBeDeleted: RemoveEmptyIds(
        prev.DynamicSubFormIdsToBeDeleted,
        newSubFormId
      ),
      data: newAllForms,
    }));
  };

  const OnBlur = (e) => {
    let allFormNames = allForms.data.map((form) => {
      return { Label: form.Label, DisplayOrder: form.DisplayOrder };
    });

    let { message, formName } = LabelBlurUtil(
      allFormNames,
      currentForm.DisplayOrder,
      e.target.value
    );

    if (!message) {
      RenameForm(formName, currentForm.DisplayOrder);
    }

    setValidationMessage(message);
  };

  const OnSave = () => {
    let allFormNames = allForms.data.map((form) => {
      return { Label: form.Label, DisplayOrder: form.DisplayOrder };
    });
    
    let { message } = LabelBlurUtil(
      allFormNames,
      currentForm.DisplayOrder,
      currentForm.Label
    );

    if (!message) {
      setFormView((prev) => ({ ...prev, isAllForm: true }));
    }

    setValidationMessage(message);
  };

  return (
    <div className="modify-form">
      <div className="modify-form-content">
        <div className="modify-form-content-input" key={currentForm?.Label}>
          <FluentInput
            placeholder={"Untitled form"}
            label={"Form Title"}
            required={true}
            defaultValue={currentForm?.Label}
            onBlur={OnBlur}
            validationMessage={validationMessage}
          ></FluentInput>
        </div>
        {currentForm?.SubForms?.map((subForm) => (
          <ModifyFormSection
            key={subForm.DisplayOrder}
            subForm={subForm}
            RenameSection={RenameSection}
            DeleteSection={DeleteSection}
            allForms={allForms}
            currentForm={currentForm}
            setAllForms={setAllForms}
            onValidationChange={onSectionValidationChange}
          />
        ))}
        <div className="modify-form-content-action">
          <div className="modify-form-content-action-add">
            <FluentButton
              icon={
                <FluentUiIcon name={"AddRegular"} color={"#bdbdbd"} size={20} />
              }
              disabled={true}
              onClick={() => {}}
              text={"Create new Form Field"}
            />
            <FluentButton
              icon={
                <FluentUiIcon
                  name={"InsertRegular"}
                  color={"#212121"}
                  size={20}
                />
              }
              onClick={AddSection}
              text={"Add new Section"}
            />
          </div>
          <div className="modify-form-content-action-exit">
            <FluentButton
              icon={
                <FluentUiIcon
                  name={"DismissRegular"}
                  color={"#212121"}
                  size={20}
                />
              }
              onClick={() =>
                setFormView((prev) => ({ ...prev, isAllForm: true }))
              }
              text={"Cancel"}
            />
            <FluentButton
              icon={
                <FluentUiIcon
                  name={"SaveRegular"}
                  color={hasAnyError ? "#bdbdbd" : "#212121"}
                  size={20}
                />
              }
              disabled={hasAnyError}
              onClick={OnSave}
              text={"Save Form"}
            />
          </div>
        </div>
      </div>
      <div className="modify-form-right-panel">
        <ModifyFormRightPanel
          subForms={currentForm?.SubForms?.map(
            ({ DisplayOrder, Label }) => `${DisplayOrder}:${Label}`
          )}
          AddFieldToSection={AddFieldToSection}
        />
      </div>
    </div>
  );
};

ModifyForm.propTypes = {
  allForms: PropTypes.object,
  currentForm: PropTypes.object,
  setAllForms: PropTypes.func,
  RenameForm: PropTypes.func,
  setFormView: PropTypes.func,
};
